import React, { useEffect, useState } from 'react';
import "../../../Css/App/AppHomeBooking.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import axios from 'axios';
import { Link } from 'react-router-dom';

const AppHomeBooking = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleFetch = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://api.woodsy.co.in/api/wood-images-product`);
            if (resp) {
                setData(resp.data);
            }
        } catch (error) {
            // console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const dbounce = setTimeout(() => {
            handleFetch();
        }, 1000);
        return () => {
            clearTimeout(dbounce);
        };
    }, []);

    return (
        <section className="home-section-app-booking-main-con">
            <div className="home-section-app-booking-detail-main-con">
                <div className="home-section-app-booking-head-con">
                    <h2>Top-Quality Plywood for Every Need</h2>
                </div>
                <div className="home-section-app-booking-details-con">
                    {loading ? (
                        <div className="loader"></div>
                    ) : (
                        <Swiper
                            slidesPerView={2}
                            spaceBetween={10}
                            centeredSlides={true}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 40,
                                },
                                1024: {
                                    slidesPerView: 5,
                                    spaceBetween: 50,
                                },
                            }}
                            className="mySwiper"
                        >
                            {
                                data.map((elem) => {
                                    const { product, sub_category, images, main_category, price, brand } = elem;
                                    return (
                                        <SwiperSlide key={elem._id || `${brand?.name}-${product}`}>
                                            <div className='home-service-app-booking-details-main-card-con'>
                                                <Link to={`/product-details/${product?.slug}`}>
                                                <div className='home-service-app-booking-details-main-card'>
                                                    <div className='d-flex justify-content-center'>
                                                        <div className='home-service-app-booking-details-main-card-image-con'>
                                                            <img
                                                                src={images?.[0] || "https://via.placeholder.com/300x200?text=No+Image"}
                                                                alt={brand?.name}
                                                                className="home-booking-image"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='home-service-app-booking-details-main-card-details-con'>
                                                        <h3>{brand?.name}</h3>
                                                        <div className='home-service-app-booking-details-main-card-time-and-price'>
                                                            <h5>₹ {price?.[0]?.price}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })
                            }
                        </Swiper>
                    )}
                    {!loading && data.length === 0 && <p>No products found.</p>}
                </div>
            </div>
        </section>
    );
};

export default AppHomeBooking;
